<h5 mat-dialog-title appLocalizationPopupDirective [localizationCode]="'TimeOffRequest'">
    {{ 'TimeOffRequest' | translate: {Default: "Time Off Request"} }}
</h5>

<mat-dialog-content>
    <div class="top">
        
        <div class="status">
            <span class="label" appLocalizationPopupDirective [localizationCode]="'Status'">{{ 'Status' | translate: {Default: "Status"} }}:</span>

                <mat-chip 
                [ngClass]="{
                    'red-chip': timeOffRequest.requestStatus?.id === 'trs_Denied',
                    'green-chip': timeOffRequest.requestStatus?.id === 'trs_Approved',
                    'orange-chip': timeOffRequest.requestStatus?.id === 'trs_Pending'
                }"
                >{{ timeOffRequest.requestStatus?.name }}</mat-chip>
            
            <div class="requested-on">
                <span class="label" appLocalizationPopupDirective [localizationCode]="'RequestedOn'">{{ 'RequestedOn' | translate: {Default: "Requested On"} }}:</span> {{ moment(timeOffRequest.requestedOn).format('lll') }}
            </div>

            <div class="status-updated-by" *ngIf="timeOffRequest.requestStatusSetBy !== null">
                <span class="label" appLocalizationPopupDirective [localizationCode]="'RequestStatusSetBy'">{{ 'RequestStatusSetBy' | translate: {Default: "Request Status Set By"} }}:</span>
                
                <div class="employee-name">
                    <app-employee-image [profilePhoto]="timeOffRequest.requestStatusSetBy?.profilePhoto" [width]="35" [height]="35" [round]="true" *ngIf="!isLoading"></app-employee-image>

                    <span class="employee">
                        {{timeOffRequest.requestStatusSetBy?.firstName}} {{timeOffRequest.requestStatusSetBy?.lastName}}
                    </span>
                </div>
            </div>

            <div class="status-date" *ngIf="timeOffRequest.requestStatusUpdatedOn !== null">
                <span class="label" appLocalizationPopupDirective [localizationCode]="'RequestStatusUpdatedOn'">{{ 'RequestStatusUpdatedOn' | translate: {Default: "Request Status Updated On"} }}:</span>

                {{ moment(timeOffRequest.requestStatusUpdatedOn).format('lll') }}
            </div>

            <div class="status-date" *ngIf="timeOffRequest.requestStatusComments">
                <div class="label" appLocalizationPopupDirective [localizationCode]="'StatusComments'">{{ 'StatusComments' | translate: {Default: "Status Comments "} }}: </div>
                {{timeOffRequest.requestStatusComments}}
            </div>
        </div>
        
        <div class="approval">
            <div class="approved-by">
                <span class="label" appLocalizationPopupDirective [localizationCode]="'Approvers'">{{ 'Approvers' | translate: {Default: "Approvers"} }}:</span>

                <ng-container *ngIf="timeOffRequest.managers.length > 1">
                    <mat-icon class="material-icons-outlined employee-list-icon" [matBadge]="timeOffRequest.managers.length" [matTooltip]="showEmployeeTooltip(timeOffRequest.managers)">
                        account_circle
                    </mat-icon>
                </ng-container>
    
                <ng-container *ngIf="timeOffRequest.managers.length == 1">
                    <ng-container *ngFor="let employee of timeOffRequest.managers">
                        <div class="employee-name">
                            <app-employee-image [profilePhoto]="employee.profilePhoto" [width]="35" [height]="35" [round]="true" *ngIf="!isLoading"></app-employee-image>
    
                            <span class="employee">
                                {{employee.firstName}} {{employee.lastName}}
                            </span>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>

    </div>
    <div class="bottom">
        <div class="employee-name">
            <app-employee-image [profilePhoto]="timeOffRequest.requestedBy?.profilePhoto" [width]="35" [height]="35" [round]="true"></app-employee-image>

            <h6 class="employee">
                {{timeOffRequest.requestedBy?.firstName}} {{timeOffRequest.requestedBy?.lastName}}
            </h6>
        </div>

        <h6>{{timeOffRequest.timeOffType?.name}}</h6>

        <h6 class="dates">
            {{ moment(timeOffRequest.from).format('ll') }} - {{ moment(timeOffRequest.to).format('ll') }}
            <mat-chip class="green-chip" *ngIf="timeOffRequest.halfDay === true" appLocalizationPopupDirective [localizationCode]="'LeaveRequestHalfDay'">{{ 'LeaveRequestHalfDay' | translate: {Default: "Half Day"} }}</mat-chip>
        </h6>

        <h6 *ngIf="timeOffRequest.endTime && timeOffRequest.endTime">{{ formatTime(timeOffRequest.startTime) }} - {{ formatTime(timeOffRequest.endTime) }}</h6>
        <h6 *ngIf="!loadingWorkingHours && workingHours" appLocalizationPopupDirective [localizationCode]="'WorkingHours'">{{workingHours}} {{ 'WorkingHours' | translate: {Default: "working hours"} }}</h6>
        <h6 *ngIf="timeOffRequest.hours" appLocalizationPopupDirective [localizationCode]="'Hours'">{{ timeOffRequest.hours }} {{ 'Hours' | translate: {Default: "hours"} }}</h6>
        
        <h6 class="comments">
            {{timeOffRequest.comments}}
        </h6>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="close" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
</mat-dialog-actions>
